module.exports = __webpack_public_path__ + "fonts/target-hit-succeed-aim.svg";